import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

export const equipmentsForLocationKey = (locationId) => ['equipmentsForLocation', locationId];
export const equipmentsForLocationFn = ({ queryKey }) =>
  apiClient.get(`${APP_API_URL}equipments/get-for-location`, {
    params: { location_id: queryKey[1] },
  });

export const useEquipmentsForLocationQuery = ({ locationId }) => {
  return useQuery({
    queryKey: equipmentsForLocationKey(locationId),
    queryFn: equipmentsForLocationFn,
    enabled: !!locationId,
    staleTime: 0,
    select: ({ data }) => data?.equipments || [],
  });
};
